import _ from 'lodash';
import {polyfill} from 'es6-promise';

class GooglePlacesAPI {

    constructor(){
        //needed for IE
        polyfill();
        this.autocompleteComponentRestrictions = {
            country: 'US'
        };
        this.autocompleteTypes = ['address'];
    }

    init(){
        if(!this.token) {
            this.token = new google.maps.places.AutocompleteSessionToken();
        }
        if(!this.autocompleteService){
            this.autocompleteService = new google.maps.places.AutocompleteService();
        }
        if(!this.PlacesService){
            this.PlacesService = new google.maps.places.PlacesService(document.createElement('div'));
        }
        if(!this.autocompleteOK){
            this.autocompleteOK = google.maps.places.PlacesServiceStatus.OK;
        }
    }

    getPlacePredictions(query){
        this.init();
        return new Promise((resolve, reject) => {
            this.autocompleteService.getPlacePredictions({
                componentRestrictions: this.autocompleteComponentRestrictions,
                types: this.autocompleteTypes,
                input: query,
                sessionToken: this.token
            }, (predictions, status) => {
                if(status === this.autocompleteOK){
                    //separate suggestion text for display
                    const formattedSuggestion = (structuredFormatting) => ({
                        mainText: structuredFormatting.main_text,
                        secondaryText: structuredFormatting.secondary_text,
                    });
                    const processedPredictions = predictions.map((p, idx) => ({
                        suggestion: p.description,
                        placeId: p.place_id,
                        active: idx === 0,
                        index: idx,
                        formattedSuggestion: formattedSuggestion(p.structured_formatting)
                    }));
                    resolve(processedPredictions);
                } else {
                    reject(status);
                }
            });
        });
    }

    convertPlaceToAddress(place){
        let newAddress = {}, street_number = '', route = '', subLocality, township, city;
        const pieces = place.address_components;
        if(pieces && pieces.length){
            for(let i=0; i<pieces.length; i++){
                const types = pieces[i].types;
                const found_street_number = _.some(types, type => type === 'street_number');
                const found_route = _.some(types, type => type === 'route');
                const found_city = _.some(types, type => type === 'locality');
                const found_subLocality = _.some(types, type => type === 'sublocality_level_1');
                const found_township = _.some(types, type => type === 'administrative_area_level_3');
                const found_state = _.some(types, type => type === 'administrative_area_level_1');
                const found_postal_code = _.some(types, type => type === 'postal_code');
                if(found_street_number){
                    street_number = pieces[i].short_name;
                } else if (found_route){
                    route = pieces[i].short_name;
                } else if (found_city){
                    city = pieces[i].short_name;
                } else if (found_subLocality){
                    subLocality = pieces[i].short_name;
                } else if (found_township){
                    township = pieces[i].short_name;
                } else if (found_state){
                    newAddress.state = pieces[i].short_name;
                } else if (found_postal_code){
                    newAddress.zip = pieces[i].short_name;
                }
            }
            if(city){
                newAddress.city = city;
            } else if (subLocality){
                newAddress.city = subLocality;
            } else if (township){
                newAddress.city = township;
            }
            if(street_number || route){
                newAddress.streetAddress = street_number + (street_number && route ? ' ' : '') + route;
            }
        }
        newAddress.formattedAddress = place.formatted_address.replace(/, USA$/, '');;
        newAddress.htmlAttributions = place.html_attributions || [];
        newAddress.isValid = false;
        newAddress.hasValidZip = !!(newAddress.zip);
        newAddress.hasValidCity = !!(newAddress.city);
        newAddress.hasValidStreetAddress = !(!street_number || !route);
        newAddress.isValid = newAddress.hasValidCity && newAddress.hasValidStreetAddress && newAddress.hasValidZip;
        return newAddress;
    }

    getPlaceDetails(placeId){
        this.init();
        return new Promise((resolve, reject) => {
            this.PlacesService.getDetails({
                placeId: placeId,
                fields: ['address_components', 'formatted_address'],
                sessionToken: this.token
            }, (place, status) => {
                this.token = new google.maps.places.AutocompleteSessionToken();
                if(status === this.autocompleteOK && place){
                    const newAddress = this.convertPlaceToAddress(place);
                    resolve(newAddress);
                } else {
                    reject(status);
                }
            });
        });
    }
}

export default GooglePlacesAPI;
